import RefreshIcon from "@assets/icons/refresh-icon.svg";
import BgEllipse from "@assets/icons/bg-ellipse-3.svg";

import usePlatformStore from "@store/usePlatformStore";
import { BackgroundSection } from "@components/Sections";
import { MainLogo } from "@ui/Logos/MainLogo";
import { Paragraph } from "@ui/Content";
import { H3 } from "@ui/Headings";

export default function EmailLoadingScreen() {
  const { isChrome } = usePlatformStore();

  return (
    <div className="flex flex-col">
      <div className="flex flex-col justify-center items-center pt-[100px]">
        <MainLogo className="pb-[50px]" />

        <div className="relative w-full">
          {isChrome() && (
            <BgEllipse className="absolute top-10 w-full z-0 pointer-events-none dark:opacity-10" />
          )}
          <BackgroundSection
            className="bg-[#4D7F7C]"
            icon={<RefreshIcon className="stroke-white stroke-[1.76] animate-slowpin-reverse" />}
          />
        </div>

        <div className="flex flex-col gap-3 items-center w-80 px-4 mt-5">
          <H3 className="text-[#406A68] dark:text-[#B9D6D1]">
            Checking email status
          </H3>
          <Paragraph>
            Please wait while we retrieve the email details…
          </Paragraph>
        </div>
      </div>
    </div>
  );
}
